document.addEventListener("turbolinks:load", function() {
	$(document).on("click","[data-submission-is-approval]", function() {
		$("#revisions").prop('disabled', true);
    $("#revisions").val('');
    $("#attached_file").prop('disabled', true);
	});
})
